import React, { useEffect, useState } from 'react';
import { Row, Col, Card as CardAntd } from 'antd';
import { Card, Icon, ProjectCard, Avatar, MemberList } from '../../components';
import { Carousel, FloatButton, Progress } from 'antd';
import CircularProgress from '../../components/basics/CircularProggress';
import { useDispatch, useSelector } from 'react-redux';
import { TodoItem } from '../Project/subpages/TaskModal/TodoSection';
import { getTemptId } from '../../utils/helpers';
import NoteItem from '../../components/NoteItem';
//import type { DatePickerProps } from 'antd';
import { DatePicker, Space } from 'antd';

import {
  createNote,
  createTodo,
  deleteNote,
  deleteTodo,
  getNotes,
  getProjects,
  getTodo,
  updateNote,
  updateTodo,
} from './actions';
import { acceptInvitation, declineInvitation } from '../Project/actions';
import { getProjectLogo } from '../../utils/helpers';
import { getInvitations } from '../Dashboard/actions';
import { IsWeb } from '../../components/basics/Platform';
import { Link } from 'react-router-dom';
import { API_GET_TASK_BY_DATE } from '../../config/API';
import axios from '../../config/axios';
import 'react-datepicker/dist/react-datepicker.css';
import { eachDayOfInterval, format as customFormat } from 'date-fns';

import moment from 'moment';
import { TASK_BY_DATE } from './constants';
import {
  FileDoneOutlined,
  FolderOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import AddTaskModel from './Modals/AddTaskModel';

const Dashboard = () => {
  const dispatch = useDispatch();
  let isWebView = IsWeb();
  const todo = useSelector((s) => s.dashboard.todo);
  const notes = useSelector((s) => s.dashboard.notes);
  const projects = useSelector((s) => s.dashboard.projects);
  const user = useSelector((s) => s.auth.user.data);
  const invitations = useSelector((s) => s.dashboard.invitations);
  const taskbydate = useSelector((s) => s.dashboard.taskbydate.payload);
  const invitationExist =
    useSelector((s) => s.dashboard.invitations.data.length) > 0 ? true : false;
  const [selectedDate, setSelectedDate] = useState(
    moment().format('YYYY-MM-DD')
  );
  const [isModalOpen, setIsModalOpen] = useState(false);

  const statistics = React.useMemo(() => {
    const total = user.tasks?.length;
    const todoSize = user.tasks?.filter((t) => t.board !== 4).length;
    const doneSize = user.tasks?.filter((t) => t.board === 4).length;
    return {
      todoSize,
      doneSize,
      todo: ((todoSize / total) * 100 || 0).toFixed(1).replace('.0', ''),
      done: ((doneSize / total) * 100 || 0).toFixed(1).replace('.0', ''),
    };
  }, [user.tasks]);

  React.useEffect(() => {
    dispatch(getNotes());
    dispatch(getTodo());
    dispatch(getInvitations());
    dispatch(getProjects());
  }, []);

  const today = new Date();
  const startDate = new Date(today);
  startDate.setDate(today.getDate() - 3);

  const endDate = new Date(today);
  endDate.setDate(today.getDate() + 3);

  const dates = eachDayOfInterval({ start: startDate, end: endDate });

  const handleDateSelect = (date, i) => {
    setSelectedDate(moment(date).format('YYYY-MM-DD'));
  };

  const datePickerSelect = (date, dateString) => {
    setSelectedDate(moment(dateString).format('YYYY-MM-DD'));
  };

  /**
   * API for Fetching tasks by date
   */
  useEffect(() => {
    let data = {
      date: selectedDate,
    };
    const fetchData = () => {
      axios
        .post(API_GET_TASK_BY_DATE, data)
        .then((response) => {
          // console.log('response get', response.data);
          dispatch({ type: TASK_BY_DATE, payload: response.data });
        })
        .catch((error) => {
          // console.log(error, 'error');
          dispatch({ type: TASK_BY_DATE, payload: [] });
        });
    };
    fetchData();
  }, [dispatch, selectedDate]);

  const addNote = React.useCallback(() => {
    if (!notes.creating)
      dispatch(createNote({ _id: getTemptId(), text: 'New note' }));
  }, [notes.creating, dispatch]);
  const updateNoteItem = React.useCallback(
    (id, val) => {
      dispatch(updateNote({ ...notes.data.find((t) => t._id === id), ...val }));
    },
    [notes.data]
  );

  const addTodo = React.useCallback(() => {
    if (!todo.creating)
      dispatch(createTodo({ _id: getTemptId(), text: 'New todo' }));
  }, [todo.creating]);
  const updateTodoItem = React.useCallback(
    (n, id, val) => {
      dispatch(updateTodo({ ...todo.data.find((t) => t._id === id), ...val }));
    },
    [todo.data]
  );

  const styles = {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
  };
  const backGround = {
    backgroundColor: '#ad64c6',
    color: 'white',
    borderRadius: '10px',
    minWidth: '30px',
    padding: '3px',
    textAlign: 'center',
  };
  const minimumWidth = {
    minWidth: '30px',
    padding: '3px',
    textAlign: 'center',
    cursor: 'pointer',
  };
  const spanStyle = {
    display: 'flex',
    justifyContent: 'space-between',
  };

  const dateColor = {
    color: '#666666',
  };

  const cardAntd = {
    maxHeight: '120px',
    width: '100%',
    position: 'relative',
    backgroundColor: '#F5F5F5',
    padding: '15px',
    borderWidth: '10px',
    borderRadius: '20px',
    borderColor: 'yellow',
    marginBottom: '15px',
  };

  const spaceStyle = {
    marginTop: '10px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const contentStyle = {
    height: '160px',
    width: '100%',
    marginLeft: '500px',
    color: '#fff',
    lineHeight: '160px',
    textAlign: 'center',
    background: '#364d79',
  };

  const NotesTitle = React.useMemo(
    () => (
      <Row align="middle cardTitle">
        Personal Notes{' '}
        <div onClick={addNote}>
          <Icon name="plus-circle" />
        </div>
      </Row>
    ),
    [notes.creating]
  );
  const TodoTitle = React.useMemo(
    () => (
      <Row align="middle cardTitle">
        Personal Todo{' '}
        <div onClick={addTodo}>
          <Icon name="plus-circle" />
        </div>
      </Row>
    ),
    [todo.creating]
  );

  const Invitations = () => {
    if (invitationExist) {
      return (
        <Col xs={24} md={12}>
          <Card
            title="Invitations"
            minHeight={isWebView ? 170 : 30}
            height={isWebView ? 200 : 85}
            overflow="scroll"
            loading={invitations.loading}
            empty={!invitations.data.length}
            className="dashboardCard"
          >
            {invitations.data.map((item) => (
              <div key={item._id} className="listItem invitation">
                <Row gutter={10} justify="middle">
                  <Col>
                    <Avatar
                      src={getProjectLogo(item.project?.image)}
                      name={item.project?.name}
                    />
                  </Col>
                  <Col>{item.project?.name}</Col>
                </Row>
                <Row>
                  <div onClick={() => dispatch(acceptInvitation(item._id))}>
                    <Icon name="chevron-up success" />
                  </div>
                  <div onClick={() => dispatch(declineInvitation(item._id))}>
                    <Icon name="close danger" />
                  </div>
                </Row>
              </div>
            ))}
          </Card>
        </Col>
      );
    } else return null;
  };

  const ProgressItem = ({ todoGroup }) => {
    const progress = React.useMemo(() => {
      if (todoGroup?.length) {
        let total = 0;
        let checked = 0;
        todoGroup.forEach((t) => {
          total += t.list.length;
          t.list.forEach((l) => {
            if (l.checked) checked += 1;
          });
        });
        return ((checked / total) * 100).toFixed(0);
      }
    }, [todoGroup]);

    return (
      <>
        {!!progress && (
          <div className="progressContainer">
            <Progress percent={progress} strokeColor="#48B990" />
          </div>
        )}
      </>
    );
  };

  return (
    <div className="dashboard">
      <div className="heading">
        <h1>Woosla</h1>
        <h4>Dashboard</h4>
      </div>
      {!isWebView ? (
        <div style={{ width: '100%', maxWidth: '75vw', maxHeight: '200px' }}>
          <Row>
            <Col>
            <Carousel autoplay effect={'scroll-x'}>
                <div>
                  <Card bordered={false}>
                    Total Journeys: <b>{projects.data.length}</b>
                  </Card>
                </div>
                <div>
                  <Card bordered={false}>
                    Acitivities Todo: <b>{statistics.todoSize}</b>
                  </Card>
                </div>
                <div>
                  <Card bordered={false}>
                    Acitivities Done: <b>{statistics.doneSize}</b>
                  </Card>
                </div>
                <div>
                  <Card bordered={false}>
                    Total Members: <b>{user.contacts?.length || 0}</b>
                  </Card>
                </div>
              </Carousel>
            </Col>
          </Row>
        </div>
      ) : (
        <Row gutter={16} className="statistics">
          <Col xs={24} sm={12} md={6}>
            <Card minHeight={85}>
              <div>Total Journeys</div>
              <b>{projects.data.length}</b>
            </Card>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Card minHeight={85}>
              <div>Acitivities Todo</div>
              <b>{statistics.todoSize}</b>
              <div className="progress">
                <CircularProgress percentage={statistics.todo} />
              </div>
            </Card>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Card minHeight={85}>
              <div>Acitivities Done</div>
              <b>{statistics.doneSize}</b>
              <div className="progress">
                <CircularProgress percentage={statistics.done} />
              </div>
            </Card>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Card minHeight={85}>
              <div>Total Members</div>
              <b>{user.contacts?.length || 0}</b>
            </Card>
          </Col>
        </Row>
      )}

      <Row gutter={20}>
        <Invitations />
        <Col xs={24} md={invitationExist ? 12 : 8}>
          <Card
            title={
              <>
                <Row style={styles}>
                  {dates.map((date, i) => (
                    <Col
                      key={date}
                      onClick={() => handleDateSelect(date, i)}
                      style={
                        moment(date).format('YYYY-MM-DD') === selectedDate
                          ? backGround
                          : minimumWidth
                      }
                    >
                      <span
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                          fontSize: 11,
                        }}
                      >
                        <span>{customFormat(date, 'd ')}</span>
                        <span>{customFormat(date, 'E ')}</span>
                      </span>
                    </Col>
                  ))}
                </Row>
                <Row style={spaceStyle}>
                  <Space direction="vertical">
                    <DatePicker onChange={datePickerSelect} />
                  </Space>
                </Row>
              </>
            }
            empty={!taskbydate.length ? true : false}
            loading={notes.loading}
            className="dashboardCard"
            minHeight={isWebView ? 160 : 150}
            height={180}
          >
            {taskbydate?.map((task) => (
              <>
                <div style={cardAntd}>
                  <b>
                    {' '}
                    {`${task.title.trim().charAt(0).toUpperCase()}${task.title
                      .trim()
                      .toLowerCase()
                      .slice(1)}`}
                  </b>
                  <br />
                  <br />
                  <span style={spanStyle}>
                    {!!task.members?.length ? (
                      <MemberList
                        members={task.members}
                        size={40}
                        overflow="hidden"
                      />
                    ) : (
                      <div />
                    )}
                    <span style={dateColor}>
                      {moment(task.createdAt).format('ddd , DD MMMM YYYY')}
                    </span>
                  </span>

                  <ProgressItem
                    key={task.todoGroup?._id}
                    todoGroup={task?.todoGroup}
                    overflow="hidden"
                  />
                </div>
              </>
            ))}
          </Card>
        </Col>
        <Col xs={12} md={invitationExist ? 12 : 8}>
          <Card
            title={NotesTitle}
            empty={isWebView ? !notes.data.length : false}
            loading={notes.loading}
            className="dashboardCard"
            minHeight={isWebView ? 200 : 85}
            height={!notes.data.length && !todo.data.length ? 5 : 100}
          >
            {notes.data.map((note) => (
              <NoteItem
                key={note._id}
                note={note}
                updateItem={updateNoteItem}
                deleteNote={(val) => dispatch(deleteNote(val))}
              />
            ))}
          </Card>
        </Col>
        <Col xs={12} md={invitationExist ? 12 : 8}>
          <Card
            title={TodoTitle}
            empty={isWebView ? !todo.data.length : false}
            loading={todo.loading}
            className="todo dashboardCard"
            minHeight={isWebView ? 200 : 85}
            height={!notes.data.length && !todo.data.length ? 5 : 100}
          >
            <div className="list">
              {todo.data.map((item) => (
                <TodoItem
                  key={item._id}
                  item={item}
                  updateTodo={updateTodoItem}
                  deleteTodo={() => dispatch(deleteTodo(item._id))}
                />
              ))}
            </div>
          </Card>
        </Col>
      </Row>
      <Link to={'projects'}>
        <h2>Journeys</h2>
      </Link>
      <div>
        <h5 style={{ marginBottom: 15 }}>
          {projects.data?.length > 6
            ? `Showing 6 out of ${projects.data?.length} Journeys`
            : ''}
          <Link
            to={'projects'}
            style={{
              backgroundColor: '#f9f9f9',
              paddingLeft: 10,
              paddingRight: 10,
              paddingTop: 5,
              paddingBottom: 5,
              borderRadius: 10,
              marginLeft: projects.data?.length > 6 ? 20 : 0,
              borderWidth: 4,
              borderColor: 'black',
            }}
          >
            View all
          </Link>
        </h5>
      </div>
      <Row gutter={20} className="projectList">
        {projects.loading ? (
          [1, 2, 3].map((x) => (
            <Col xs={24} md={12} lg={8} key={x}>
              <Card loading minHeight={200} />
              <br />
            </Col>
          ))
        ) : !!projects.data.length ? (
          projects.data
            .slice(0, 6)
            .filter((p) => !p.archived)
            .map((item) => (
              <Col xs={24} md={12} lg={8} key={item._id}>
                <ProjectCard data={item} />
              </Col>
            ))
        ) : (
          <Col xs={24}>
            <Card empty />
          </Col>
        )}
        <FloatButton.Group
          trigger="click"
          type="primary"
          style={{ right: 24 }}
          icon={<PlusOutlined />}
        >
          <FloatButton
            icon={<FileDoneOutlined />}
            tooltip={<div>Add new Task</div>}
            onClick={() => {
              setIsModalOpen(true);
            }}
          />
          <FloatButton
            icon={<FolderOutlined />}
            tooltip={<div>Create new Journey</div>}
          />
        </FloatButton.Group>
      </Row>
      <AddTaskModel isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
    </div>
  );
};

export default Dashboard;
